export function hashCode(str: string): number {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
}

export type LinkifyPart = { type: 'text'; value: string } | { type: 'link'; value: string; href: string };

const URL_REGEX = /(?:https?:\/\/|www\.)[^\s<]+/gi;
const TRAILING_PUNCTUATION = /[.,;:!?'"]+$/;

/**
 * Splits text into plain-text and link segments so callers can render detected URLs as
 * anchors without resorting to v-html. Matches http(s):// and www. URLs and keeps sentence
 * punctuation that abuts a URL out of the link.
 */
export function linkifyText(text: string): LinkifyPart[] {
    const parts: LinkifyPart[] = [];
    let lastIndex = 0;

    for (const match of text.matchAll(URL_REGEX)) {
        const start = match.index;
        let url = match[0];
        let trailing = '';

        const punctuation = url.match(TRAILING_PUNCTUATION);
        if (punctuation) {
            trailing = punctuation[0];
            url = url.slice(0, -trailing.length);
        }
        // A closing paren only belongs to the URL if it opened one (e.g. wiki links).
        if (url.endsWith(')') && !url.includes('(')) {
            trailing = `)${trailing}`;
            url = url.slice(0, -1);
        }

        if (start > lastIndex) parts.push({ type: 'text', value: text.slice(lastIndex, start) });
        parts.push({ type: 'link', value: url, href: /^www\./i.test(url) ? `https://${url}` : url });
        if (trailing) parts.push({ type: 'text', value: trailing });

        lastIndex = start + match[0].length;
    }

    if (lastIndex < text.length) parts.push({ type: 'text', value: text.slice(lastIndex) });
    return parts;
}
